import React, { useState } from 'react';
import './css/style.scss';

import { Swiper, SwiperSlide } from 'swiper/react';
import 'swiper/css';
import 'swiper/css/effect-fade';
import 'swiper/css/autoplay';
import SwiperCore, { EffectFade, Autoplay } from 'swiper';
import { specialityPopOver, specialityPopOverFromArray } from '../../../../common/common';
import ShareCard from '../../../ShareCard';
// import ReactHtmlParser from 'react-html-parser';
import { reactHtmlParser } from '../../../../common/common';
import LazyImage from '../../../CustomLibraries/LazyImage';
import useRedirect from '../../../customHooks/useRedirect';
import { surveys_static_image } from '../../../../common/assets.common';
import { removeHtmlTags } from '../../../../pages/channel/utils';
import { useTrackUserActivity } from '../../../customHooks/useTrackUserActivity';
import InView from 'react-intersection-observer';

// install Swiper modules
SwiperCore.use([EffectFade, Autoplay]);

export default function SurveyCardV1({
  data = '',
  hideImage = false,
  status = '',
  pending = false,
  click,
  isChannel = false,
  gtmTagVariable = ''
}) {
  const { redirectTo } = useRedirect();
  const cardClick = () =>
    click ? click() : redirectTo('SPQdetails', data.survey_id, data.survey_title);
  const [isHoverd, setIsHoverd] = useState(false);
  const shareClick = () => {};
  let sponsorLogo = isChannel
    ? data?.sponsor_names_and_logos?.map((_) => _.client_logo)
    : data?.sponsor_logo
    ? data?.sponsor_logo.split(',')
    : [];
  const { userActivityTracker } = useTrackUserActivity();
  return (
    <InView
      as="div"
      onChange={(inView) => {
        userActivityTracker(inView, { type: 'survey', ...data }, 'card');
      }}
    >
      <div className="w-100 float-start surveyCardV1Box shadow rounded-3 overflow-hidden bg-white position-relative">
        <span
          className="graph-1 position-absolute start-0 bottom-0"
          style={{ backgroundColor: data?.color ?? '#355fd3' }}
        ></span>
        <span
          className="graph-2 position-absolute start-0 bottom-0"
          style={{ backgroundColor: data?.color ?? '#355fd3' }}
        ></span>

        {hideImage ? null : (
          <div
            className="w-100 float-start surveyCardV1BoxPic cursorPointer overflow-hidden position-relative"
            onClick={cardClick}
          >
            <LazyImage
              src={data?.image ?? surveys_static_image}
              alt="banner"
              className={`object-fit-cover w-100 h-100 float-start gtm_cl_surveyCard`}
              fallback_image={surveys_static_image}
            />

            <div
              className={`overlay bg-black bg-opacity-50 gtm_cl_surveyCard`}
              // id={`surveyCard_image_${data.survey_id}`}
            ></div>
            <div className="surveyCardV1Point rounded position-absolute z-2 py-2 px-4 bg-secondary">
              <h5 className="fw-normal text-center text-white fs-4">
                <span className="fw-bold">{data?.point} </span>
                Points
              </h5>
            </div>
          </div>
        )}
        <div className="w-100 float-start surveyCrdV1Btm p-3  ps-0 ps-lg-0">
          <div className="crdV1topPart d-flex align-items-center justify-content-between position-relative mb-2 py-2 ps-4">
            <span
              className="crdV1topPartGraph position-absolute start-0 top-50 translate-middle-y"
              style={{ backgroundColor: data?.color ?? '#355fd3' }}
            ></span>
            <div className="text-black crdV1Speclty d-flex gap-2">
              <span
                className={`fs-4 cursorPointer gtm_cl_surveyCard_specialities`}
                // id={`surveyCard_specialities_${data.survey_id}`}
                onClick={() => {
                  if (data?.specialities_ids_and_names) {
                    redirectTo(
                      'Speciality',
                      data?.specialities_ids_and_names[0]?.id,
                      data?.specialities_ids_and_names[0]?.name
                    );
                  }
                }}
              >
                {data?.specialities_ids_and_names?.length > 0
                  ? data?.specialities_ids_and_names[0]?.name
                  : data?.specialities_name?.split(',')[0]}{' '}
              </span>
              {data?.specialities_ids_and_names?.length > 0
                ? specialityPopOverFromArray(data?.specialities_ids_and_names)
                : specialityPopOver(data?.specialities_name)}
            </div>
            <div className="surveyCardV1TopRight d-inline-flex align-items-center">
              <span className="text-black fs-4 fw-normal cardV1tagSpq border border-dark me-4 py-1 px-3">
                Survey
              </span>
              <a href="javascript:void(0)" className="cardV1DotsMenu text-black">
                <ShareCard
                  gtmTagVariable={`gtm_cl_surveyCard_share`}
                  shareClick={shareClick}
                  data={{ title: data?.survey_title, url: data?.deeplink }}
                  // id={`${gtmTagVariable}_surveyCard_share_${data.survey_id}`}
                  customClass={`${gtmTagVariable}_surveyCard_share fs-3`}
                />
              </a>
            </div>
          </div>

          <div className="w-100 float-start d-flex text-start cardV1Topic mb-2 ps-4">
            {/* withChanel */}
            {/* <div className="rounded-circle cardV1ProfilePic overflow-hidden d-flex justify-content-center align-items-center border border-light">
                <img
                    src="https://cdn1.vectorstock.com/i/1000x1000/74/45/line-letter-m-square-logo-design-inspiration-vector-26437445.jpg" />
            </div> */}
            {/* withChanel */}

            <div
              className="cardV1TopicContent cursorPointer position-relative w-100"
              onClick={cardClick}
            >
              <h2
                className={`text-black fs-16 fw-medium mb-2 gtm_cl_surveyCard text-break`}
                // id={`surveyCard_title_${data.survey_id}`}
              >
                {data?.survey_title}
              </h2>
              <p
                className={`text-dark fs-4 line-clamp-2 gtm_cl_surveyCard`}
                // id={`surveyCard_description_${data.survey_id}`}
              >
                {removeHtmlTags(data?.survey_description)}
              </p>
            </div>
          </div>
          {isChannel && data?.channels?.length > 0 && (
            <div
              className="w-100 float-start d-flex text-start cardV1Topic mb-2 ps-4"
              onClick={() =>
                redirectTo(
                  'ChannelProfile',
                  data?.channels[0]?.channel_id,
                  data?.channels[0]?.channel_name
                )
              }
            >
              <div className="spqChannel d-flex align-items-center mt-3">
                <div className="channelPic rounded-circle overflow-hidden me-3">
                  <LazyImage
                    src={data?.channels[0]?.channel_logo}
                    alt="Channel Name"
                    className={`mw-100 mh-100 w-auto h-auto gtm_cl_surveyCard_channel`}
                    logo
                    // id={`surveyCard_channelPic_${data?.channels[0]?.channel_id}`}
                  />
                </div>
                <div className="channelName flex-grow-1">
                  <h5
                    className={`fs-4 fw-medium text-dark line-clamp-2 gtm_cl_surveyCard_channel`}
                    // id={`surveyCard_channelName_${data?.channels[0]?.channel_id}`}
                  >
                    {data?.channels[0]?.channel_name}
                  </h5>
                </div>
              </div>
            </div>
          )}
          <div className="w-100 float-start cardV1Ftr d-flex align-items-center justify-content-between ps-4 mt-2">
            {/* sponser logo if single ================*/}
            {sponsorLogo?.length == 1 && (
              <div className="crdV1sponser m-0 text-start">
                <div className="crdV1sponserIn w-100 bg-white position-relative">
                  <LazyImage
                    className="position-absolute start-0 top-50 translate-middle-y"
                    src={sponsorLogo[0]}
                    alt="sponsor"
                    logo
                  />
                </div>
              </div>
            )}
            {sponsorLogo?.length == 0 && (
              <div className="crdV1sponser m-0 text-start">
                <div className="crdV1sponserIn w-100 bg-white position-relative"></div>
              </div>
            )}
            {/* sponser logo if single */}

            {/* sponser logo if multiple */}
            {sponsorLogo?.length > 1 && (
              <Swiper
                className="crdV1sponser m-0 text-start"
                navigation={false}
                spaceBetween={0}
                slidesPerView={1}
                loop={true}
                autoplay={{
                  delay: 2500
                }}
                effect={'fade'}
              >
                {sponsorLogo.map((logo, _i) => (
                  <SwiperSlide
                    className="crdV1sponserIn w-100 bg-white position-relative"
                    key={_i + 1}
                  >
                    <LazyImage
                      className="position-absolute start-0 top-50 translate-middle-y"
                      src={logo}
                      alt="sponsor"
                      logo
                    />
                  </SwiperSlide>
                ))}
              </Swiper>
            )}

            <div
              className="cardV1FtrBtn d-inline-block overflow-hidden py-3 px-4 fs-4 fw-medium rippleEffect rounded cursorPointer gtm_cl_surveyCard"
              onClick={cardClick}
              onMouseEnter={() => {
                setIsHoverd(true);
              }}
              onMouseLeave={() => {
                setIsHoverd(false);
              }}
              style={{
                border: `${
                  isHoverd
                    ? '1px solid transparent'
                    : `1px solid ${data?.color ? data?.color : '#355fd3'}`
                }`,
                // color: `${isHoverd ? '#fff' : cardData?.color ?? '#355fd3'}`,
                backgroundColor: `${
                  isHoverd ? (data?.color ? data?.color : '#355fd3') : 'transparent'
                }`
              }}
            >
              {/* <div
              className="cardV1BtnHover position-absolute top-50 start-50 translate-middle gtm_cl_surveyCard"
              style={{ backgroundColor: data?.color ?? '#355fd3' }}
            ></div>
            <div
              className="cardV1BtnBorder rounded position-absolute start-0 top-50 translate-middle-y gtm_cl_surveyCard"
              style={{ borderColor: data?.color ?? '#355fd3' }}
            ></div> */}
              <span
                style={{ color: `${isHoverd ? '#fff' : data?.color ?? '#355fd3'}` }}
                className="gtm_cl_surveyCard d-flex gap-1 align-items-center"
              >
                {pending ? 'Continue' : status == 'completed' ? 'Review' : 'Begin'}{' '}
                <i
                  className="flaticon-next fs-4 ms-2 gtm_cl_surveyCard d-flex align-items-center"
                  id={`surveyCard_button_icon_${data.survey_id}`}
                ></i>
              </span>
            </div>
          </div>
        </div>
      </div>
    </InView>
  );
}
